import script from "./ContactTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContactTopComponent.vue?vue&type=style&index=0&id=96e701ae&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96e701ae"]])

export default __exports__